import { render } from "./Products.vue?vue&type=template&id=4147efc8&scoped=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import "./Products.vue?vue&type=style&index=0&id=4147efc8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4147efc8"

export default script